// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tags_tag__LWjjG","tag_active":"Tags_tag_active__yXMVx","tags":"Tags_tags__3qUBx","reset":"Tags_reset__1dpht"};